import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Clients = () => {
    const { data } = useLanguage();
    const clientsData = data.ourclients;

    if (!clientsData.active) return null;

    return (
        <section id="clients" className="py-20 px-4 md:px-8">
            <div className="container mx-auto">
                <h2 className="section-title mb-16">{clientsData.title}</h2>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-12 items-center">
                    {clientsData.nodes.map((client) => (
                        <div key={client.id} className="flex items-center justify-center">
                            <img
                                src={client.logo}
                                alt={client.name}
                                className="h-16 w-auto object-contain transition-opacity duration-300 hover:opacity-80"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
